module.exports = __webpack_public_path__ + "static/media/narmena-life-vertical.85a75220.jpg";